import PaymentAttributeList from '@/controllers/payment_attribute/payment-attribute-list.js';

export default {
  extends: PaymentAttributeList,
}
